import { render } from "./GridMeniuCustom.vue?vue&type=template&id=c464f27c&scoped=true&ts=true"
import script from "./GridMeniuCustom.vue?vue&type=script&lang=ts"
export * from "./GridMeniuCustom.vue?vue&type=script&lang=ts"

import "./GridMeniuCustom.vue?vue&type=style&index=0&id=c464f27c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c464f27c"]])

export default __exports__